window.StartHiringForm = function (scope, wotcDataService, userPermissions) {
    var self = this;
    var formName = "start-hiring-form";
    var _protected = BaseForm.call(self, formName, scope);
    var _emitter = JarEventEmitter.call(self);

    var employee_first_day;
    self.load = function (OBIdObj) {
        self.data = {};
        self.OBIdObj = OBIdObj || {};
        self.coreHREmployeeDetails = self.OBIdObj.coreHREmployeeDetails;
        self.lastTerminationDate = "";

        if (self.coreHREmployeeDetails) {
            self.employmentPeriods = self.coreHREmployeeDetails.employment_periods && self.coreHREmployeeDetails.employment_periods;
            self.isUserOnExistingFinancialUnit = self.OBIdObj.isUserOnExistingFinancialUnit;
            var latestEmploymentPeriod = self.coreHREmployeeDetails && self.coreHREmployeeDetails.employment_periods && self.coreHREmployeeDetails.employment_periods[self.coreHREmployeeDetails.employment_periods.length - 1];
            self.hireDate = latestEmploymentPeriod && latestEmploymentPeriod.hire_date;
        }

        self.employeeName = self.OBIdObj.candidate_fname + ' ' + self.OBIdObj.candidate_lname;
        self.brand_id = self.OBIdObj.brand_id;
        self.app_id = self.OBIdObj.app_id || null;
        self.prospect_id = self.OBIdObj.prospect_id || null;
        self.job = self.OBIdObj.job;
        self.position = self.OBIdObj.position;
        self.categoryInfo = self.is_recruitment_hub ? self.OBIdObj.position?.category : self.OBIdObj.position?.position_type;
        self.is_walkin = self.OBIdObj.is_walkin ? self.OBIdObj.is_walkin : (self.prospect_id && !self.app_id);
        self.is_recruitment_hub = self.OBIdObj.is_recruitment_hub;
        self.isTeamSchedulingEnabled = OBIdObj.isTeamEnabled;
        self.loadingData = true;
        var defer = $q.defer();

        var promises = {
            'setStartDate': self.setStartDate(),
        };
        wotcDataService.checkWotcService(self.brand_id)
            .then(function (isWotcServiceEnabled) {
                if (isWotcServiceEnabled) {
                    promises['checkWotcStatus'] = self.checkWotcStatus();
                }

                $q.all(promises).then(function (res) {
                    self.loadingData = false;
                    defer.resolve();
                }).catch(function (err) {
                    self.loadingData = false;
                    defer.resolve();
                }).finally(() => {
                    self.syncScope();
                });

            });
        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule) {
        switch (rule.name) {
            case "withinClosedPeriod":
                if (self.coreHREmployeeDetails.latest_pay_sheet_close_date) {
                    return moment(self.data.hiringDate).isAfter(moment(self.coreHREmployeeDetails.latest_pay_sheet_close_date));
                }
                return true

            case "past-hire-date":
                for (var i in self.employmentPeriods) {
                    var terminationDate = self.employmentPeriods[i].leave_date;
                    if (moment(self.data.hiringDate).isSameOrBefore(terminationDate)) {
                        return false;
                    }
                }
        }
        return true;
    };

    self.checkWotcStatus = async function () {
        const defer = $q.defer();
        const promises = {};
        let hasViewOnboardingPerm = false;
        try {
            promises['settings'] = wotcDataService.getBrandWotcSettings(self.brand_id);
            promises['policyParser'] = userPermissions.getBrandPolicy(self.brand_id);
            const result = await $q.all(promises);
            const settings = result['settings'] || {};
            const policyParser = result['policyParser'];

            if (Object.keys(self.position).length > 0) {
                hasViewOnboardingPerm = policyParser.position(self.categoryInfo?.code, self.position?.code).hasAny(userPermissions.VIEW_ONBOARDING);
            }
            if (settings['provider'] && settings['provider'] === "ADP") {
                self.data.allow_wotc_fields = true;
                try {
                    if ((!(self.is_walkin || self.is_recruitment_hub) && self.app_id) ||
                        ((self.is_walkin || self.is_recruitment_hub) && hasViewOnboardingPerm)) {
                        const offerData = await OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, self.app_id);
                        const offerMetaData = offerData.meta_data || {};
                        self.data.actual_start_date = offerMetaData.start_date && new Date(offerMetaData.start_date);
                        self.data.offer_sent_date = offerData.state_changed_on && new Date(offerData.state_changed_on);
                        self.data.wage = offerMetaData.salary && parseFloat(offerMetaData.salary);
                    }

                    if (self.is_walkin || self.is_recruitment_hub) {
                        const locations = await BrandAPI.getBrandPublicLocations(self.brand_id);
                        const brand_locations = locations || [];
                        self.jobLocations = brand_locations.map(location => location.Location);
                    } else if (self.job) {
                        self.jobLocations = self.job && self.job.JobLocation;
                    } else {
                        const response = await OnBoardingAPI.getJobLocations(self.brand_id, self.prospect_id);
                        self.jobLocations = response?.job?.locations;
                    }
                } catch (e) {
                    console.error(e);
                }
            } else if (settings['provider'] && settings['provider'] === "TCC") {
                self.data.allow_tcc_fields = true;
                if ((!(self.is_walkin || self.is_recruitment_hub) && self.app_id) ||
                    ((self.is_walkin || self.is_recruitment_hub) && hasViewOnboardingPerm)) {
                    const promises = {};
                    promises['offerData'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, self.app_id);
                    promises['i9Data'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'I9', self.prospect_id, self.app_id);
                    promises['w4Data'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'W4', self.prospect_id, self.app_id);

                    const result = await $q.all(promises);

                    const offerMetaData = result['offerData'].meta_data || {};
                    const i9MetaData = result['i9Data'].meta_data || {};
                    const w4MetaData = result['w4Data'].meta_data || {};
                    const personalInfo = i9MetaData.personal_information || w4MetaData.personal_information;
                    if (personalInfo) {
                        self.data.birth_date = moment(personalInfo.birthdate);
                        self.data.ssn = personalInfo.ssn;
                    }

                    self.data.actual_start_date = offerMetaData.start_date && moment(offerMetaData.start_date);
                    self.data.offer_sent_date = offerMetaData.state_changed_on && moment(offerMetaData.state_changed_on);
                    self.data.wage = offerMetaData.salary && parseFloat(offerMetaData.salary);
                    if (offerMetaData.position_name) {
                        self.data.position_title = offerMetaData.position_name && offerMetaData.position_name;
                    } else {
                        let positionName;
                        if (self.job) {
                            if (self.job.alias_position) {
                                positionName = self.job.alias_position;
                            } else if (self.job.Position) {
                                positionName = self.job.Position.name;
                            }
                        } else if (self.position) {
                            positionName = self.position.alias || self.position.name;
                        }

                        self.data.position_title = positionName || "";
                    }
                }
            } else if (settings?.provider === wotcDataService.PROVIDER_TYPES.SYNERGI) {
                self.data.showSynergyfields = true;
                if ((!(self.is_walkin || self.is_recruitment_hub) && self.app_id) ||
                    ((self.is_walkin || self.is_recruitment_hub) && hasViewOnboardingPerm)) {
                    const lastDoc = await OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, self.app_id);
                    const offerMetaData = lastDoc.meta_data || {};
                    self.data.wage = offerMetaData.salary && parseFloat(offerMetaData.salary);
                    let positionName;
                    if (self.job) {
                        if (self.job.alias_position) {
                            positionName = self.job.alias_position;
                        } else if (self.job.Position) {
                            positionName = self.job.Position.name;
                        }
                    } else if (self.position) {
                        positionName = self.position.alias || self.position.name;
                    }
                    self.data.position_title = positionName || "";
                }
            }
            defer.resolve();
        } catch (err) {
            defer.reject(err);
        }

        return defer.promise;
    };

    self.setStartDate = function () {
        var defer = $q.defer();

        if (self.OBIdObj.start_date) {
            self.data.hiringDate = moment.parseZone(self.OBIdObj.start_date).format("MMM DD, YYYY");
            defer.resolve();
        } else {
            OnBoardingAPI.listDocuments(self.OBIdObj.app_id, self.OBIdObj.prospect_id, 'ON_BOARDING', null, true, null, OnBoardingAPI.DOCUMENT_TYPE.I9)
                .then(function (docList) {

                    docList = docList || [];
                    docList[0] = docList[0] || {};
                    docList[0].Document = docList[0].Document || {};
                    docList[0].Document.meta_data = docList[0].Document.meta_data || {};

                    if (docList[0].Document.meta_data.employee_first_day) {
                        var i9_hiring_date = moment(docList[0].Document.meta_data.employee_first_day);
                        self.data.hiringDate = i9_hiring_date;
                        employee_first_day = i9_hiring_date.format("MMM DD, YYYY");
                    }

                    try {
                        scope.$digest()
                    } catch (e) {
                    }
                }, function (err) {
                    throw err;
                });

            defer.resolve();
        }

        return defer.promise;
    };

    self.handleMismatchHireDateChange = function () {
        if (employee_first_day && self.data.hiringDate) {
            var dateDifferenceAsDays = moment(self.data.hiringDate, "MMM DD, YYYY").diff(moment(employee_first_day, "MMM DD, YYYY"), 'days');
            self.isShowWarningMsg = (dateDifferenceAsDays !== 0);
        }
    };

    self.onSelectedWorkLocation = function () {
        var defer = $q.defer();
        delete self.data.mapping_error;
        wotcDataService.getLocationMappings(self.brand_id, self.data.assigned_work_location)
            .then(function (response) {
                if (response.location_mappings.length === 0) {
                    self.data.mapping_error = true;
                }
                defer.resolve();
            }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.save = function () {
        var deferred = $q.defer();
        if (self.validator.validate() && !self.data.mapping_error) {
            deferred.resolve(self.data);
        } else {
            deferred.resolve({});
        }
        return deferred.promise;
    };
};
